import {
  getSemestresService, insertSemestreService, updateSemestreService, getPeriodosService,
  getCurrentSemestreService, insertPeriodoService, getBecasDisponiblesService, updatePeriodoService,
  getRegistrosBySemestreService, validateDocumentsService, acceptRegisterService, getRegistroDetailService, getCurrentPeriodoService,
} from "../helpers/services";

// FUNCIONES RELACIONADAS A SEMESTRES

export const getSemestres = async ({ commit }, values) => {
  const response = await getSemestresService(values);
  return response;
};

export const insertSemestre = async ({ commit }, values) => {
  const response = await insertSemestreService(values);
  return response;
};

export const updateSemestre = async ({ commit }, values) => {
  const response = await updateSemestreService(values);
  return response;
};

export const getCurrentSemestre = async ({ commit }, values) => {
  const response = await getCurrentSemestreService(values);
  return response;
};

// FUNCIONES RELACIONADAS A PERIODOS

export const getPeriodos = async ({ commit }, values) => {
  const response = await getPeriodosService(values);
  return response;
};

export const insertPeriodo = async ({ commit }, values) => {
  const response = await insertPeriodoService(values);
  return response;
};

export const updatePeriodo = async ({ commit }, values) => {
  const response = await updatePeriodoService(values);
  return response;
};


export const getCurrentPeriodo = async ({ commit }, values) => {
  const response = await getCurrentPeriodoService(values);
  return response;
};

// FUNCIONES RELACIONADAS A REGISTROS

export const getRegistrosBySemestre = async ({ commit }, values) => {
  const response = await getRegistrosBySemestreService(values);
  return response;
};

export const getRegistroDetail = async ({ commit }, values) => {
  const response = await getRegistroDetailService(values);
  return response;
};

export const acceptRegister = async ({ commit }, values) => {
  const response = await acceptRegisterService(values);
  return response;
};

// FUNCIONES GENERALES

export const getBecasDisponibles = async ({ commit }, values) => {
  const response = await getBecasDisponiblesService(values);
  return response;
};


export const validateDocuments = async ({ commit }, values) => {
  const response = await validateDocumentsService(values);
  return response;
};